/* ============================================================
   Empress menu 2026 (Oct 2026). Loaded by sections/header.liquid only while "Use the new menu" is ticked.

   1. This week's drop: keeps every [data-ee-drop] card on the right state (counting down, or live) and its
      countdown current. Same rule as the drop page (sections/countdown-banner.liquid, auto mode): the drop is at
      the set weekday and hour in AEST (UTC+10, Queensland has no daylight saving) and stays live for the set hours.
      Updates every 30 seconds. Days, hours and minutes only: nothing ticks.
   2. Search box in the drawer: a real form (Prestige predictive search fills the results); we only track submits.
   3. Reduced motion: when the phone asks for less motion, the drawer opens and closes with no slide.
   4. GA4: menu_open and menu_click (layer, label, position), same page gtag as the popup events.
   ============================================================ */
(function () {
  'use strict';

  var OFFSET = 10 * 3600 * 1000;
  var WEEK = 7 * 86400 * 1000;

  /* ---------- 1. Drop card ---------- */

  function nextDropAfter(t, weekday, hour) {
    var aest = new Date(t + OFFSET);
    var until = (weekday - aest.getUTCDay() + 7) % 7;
    var at = Date.UTC(aest.getUTCFullYear(), aest.getUTCMonth(), aest.getUTCDate() + until, hour, 0, 0) - OFFSET;
    if (at <= t) at += WEEK;
    return at;
  }

  function paintDrop(card) {
    var weekday = parseInt(card.dataset.weekday, 10);
    var hour = parseInt(card.dataset.hour, 10);
    var liveMs = (parseFloat(card.dataset.liveHours) || 48) * 3600 * 1000;
    if (isNaN(weekday) || isNaN(hour)) return;

    var now = Date.now();
    var next = nextDropAfter(now, weekday, hour);
    var live = card.dataset.hasLive === '1' && now - (next - WEEK) < liveMs;

    card.classList.toggle('is-live', live);
    var label = live ? 'drop_live' : 'drop_coming';
    if (card.getAttribute('data-ee-label') !== label) card.setAttribute('data-ee-label', label);
    var href = live ? card.dataset.liveUrl : card.dataset.beforeUrl;
    if (href && card.getAttribute('href') !== href) card.setAttribute('href', href);
    if (live) return;

    // digits through the shared countdown engine (snippets/ee-countdown): Clarity re-reads the page after every
    // change, so the page itself isn't rewritten when the minute ticks over
    if (!card.eeCountdown && window.EECountdown) {
      card.eeCountdown = window.EECountdown({
        d: card.querySelector('[data-d]'),
        h: card.querySelector('[data-h]'),
        m: card.querySelector('[data-m]'),
        pad: false
      });
    }
    if (card.eeCountdown) { card.eeCountdown.show(next); return; }

    var mins = Math.max(0, Math.floor((next - now) / 60000));
    var set = function (sel, value) {
      var el = card.querySelector(sel);
      if (el && el.textContent !== String(value)) el.textContent = value;
    };
    set('[data-d]', Math.floor(mins / 1440));
    set('[data-h]', Math.floor(mins / 60) % 24);
    set('[data-m]', mins % 60);
  }

  function paintDrops() {
    document.querySelectorAll('[data-ee-drop]').forEach(paintDrop);
  }

  /* ---------- 4. Tracking ---------- */

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        var data = { nav_version: '2026' };
        for (var k in params) data[k] = params[k];
        window.gtag('event', name, data);
      }
    } catch (e) {}
  }

  function label(el) {
    var text = el.getAttribute('data-ee-label') || el.getAttribute('aria-label') || el.innerText || el.textContent || '';
    return text.replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function onClick(event) {
    var link = event.target.closest('a');
    if (!link) return;
    var inDrawer = link.closest('[data-ee-nav]');
    var inMega = link.closest('.mega-menu, .header__primary-nav');
    if (!inDrawer && !inMega) return;

    var layerEl = link.closest('[data-ee-layer]');
    var layer = layerEl ? layerEl.getAttribute('data-ee-layer') : (link.closest('.mega-menu') ? 'mega' : 'bar');
    var position = 0;
    var item = link.closest('li');
    if (item && item.parentElement) position = Array.prototype.indexOf.call(item.parentElement.children, item) + 1;

    track('menu_click', {
      menu_layer: layer,
      menu_label: label(link),
      menu_position: position,
      menu_where: inDrawer ? 'phone' : 'desktop'
    });
  }

  /* ---------- 3. Reduced motion, and menu_open ---------- */

  function setUpSidebar() {
    var sidebar = document.getElementById('sidebar-menu');
    if (!sidebar) return;

    if (!sidebar.dataset.eeListen) {
      sidebar.dataset.eeListen = '1';
      sidebar.addEventListener('dialog:after-show', function () {
        paintDrops();
        track('menu_open', { menu_where: 'phone' });
      });
    }

    /* Only once Prestige has defined the drawer, so its own animation methods exist to wrap */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce || !reduce.matches || sidebar.dataset.eeStill) return;
    if (typeof sidebar.createEnterAnimationControls !== 'function') return;
    sidebar.dataset.eeStill = '1';
    ['createEnterAnimationControls', 'createLeaveAnimationControls'].forEach(function (name) {
      var original = sidebar[name];
      sidebar[name] = function () {
        var controls = original.apply(this, arguments);
        try { controls.finish(); } catch (e) {}
        return controls;
      };
    });
  }

  /* ---------- 2b. Keep the keyboard down when the menu opens ----------
     Prestige's focus trap focuses the first field in the drawer on open, which is now the search box, so Android
     would raise the keyboard every time. Only a tap on the box (or Tab from a keyboard) may focus it; any other
     focus moves to the menu itself. */
  var tabbing = false;
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      tabbing = true;
      setTimeout(function () { tabbing = false; }, 300);
    }
  });

  function guardSearchFocus() {
    var nav = document.querySelector('[data-ee-nav]');
    var input = nav && nav.querySelector('.ee-nav__search-input');
    if (!input || input.dataset.eeGuard) return;
    input.dataset.eeGuard = '1';
    var tapped = false;
    var markTapped = function () { tapped = true; };
    input.addEventListener('pointerdown', markTapped);
    /* Clear puts the cursor back in the box (Prestige focuses it on reset), so the keyboard stays up */
    var clear = nav.querySelector('.ee-nav__search-clear');
    if (clear) clear.addEventListener('pointerdown', markTapped);
    input.addEventListener('focus', function () {
      if (tapped || tabbing) { tapped = false; return; }
      nav.setAttribute('tabindex', '-1');
      nav.focus({ preventScroll: true });
    });
  }

  function init() {
    paintDrops();
    setUpSidebar();
    guardSearchFocus();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', function (event) {
    if (event.target.closest && event.target.closest('[data-ee-search-form]')) {
      track('menu_search', { menu_where: 'phone' });
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* The custom element may upgrade after this file runs */
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('header-sidebar').then(setUpSidebar);
  }
  setInterval(paintDrops, 30000);
})();
